 <div class="signup-short-flow__container {{campaignMode && 'db-campaign'}} {{!!showClose && 'with-close-btn'}}" [class.popup]="brandKitPopup" [class.slim]="slim" [class.email-closed]="!showEmailForm">
   <div class="signup-short-flow__close" [class.center]="centerCloseBtn" [class.opened]="showEmailForm" [class.hide]="!showClose" *ngIf="brandKit">
     <div class="close-btn"  (click)="closeBrandKit.emit()">
       <div class="action-text">Hide Sign up Form</div>
       <div class="action-icon">
         <i class="db-icon db-icon-ds-arrow-sharp"></i>
       </div>
     </div>
   </div>

   <div class="signup-short-flow__content">
    <div class="signup-short-flow__header" [class.popup]="brandKitPopup" [class.centered-outline]="centeredOutline" [class.email-opened]="showEmailForm">
      <h1 class="signup-short-flow__title {{campaignMode ? 'mb32' : !isMobile ? 'mb8' : ''}}" [class.slim]="slim" [ngClass]="{'text-center': !!textCenter}"
          [innerHTML]="title || alternativeSignUpText || 'Signup to get access to<br> customize your brand kit.<br> *Free forever'"></h1>
      <p class="signup-short-flow__subtitle"  *ngIf="!hideSubTitle">{{'text_getStartedNowNoCreditCard' | dbText}}</p>
    </div>


    <form [formGroup]="signUpForm" class="create-ai-assistant-form-view__form">
      @if (!showEmailForm) {
        <div class="auth-sign-up__form-inputs">
          <div>
            <div class="db-google-block {{!campaignMode ? 'mb16' : ''}}" [ngClass]="{'db-campaign': campaignMode}" *ngIf="companyInfo?.branding?.google_client_id">
              <db-google-auth (verifyGoogleToken)="signUpWithGoogle($event)"
                              [loading]="googleBtnLoading" [size]="'ds-btn-max'"
                              [color]="'ds-btn-black'"
                              [googleClientId]="companyInfo?.branding?.google_client_id"></db-google-auth>
            </div>

            <div class="db-email-block" *ngIf="!campaignMode">
              <a (click)="signUpWithEmail()" class="db-button_email ds-btn-white-gray-border ds-btn-max"><i
                class="db-icon db-icon-ds-email"></i>
                <span>Sign up with Email</span>
              </a>
            </div>

        </div>
      </div>
      } @else {
      <div class="auth-sign-up__form-inputs">
        <div>
     <!--     <div class="db-google-block mt24">
            <db-google-auth (verifyGoogleToken)="signUpWithGoogle($event)" [loading]="googleBtnLoading" [size]="'ds-btn-max'"
                            [color]="'ds-btn-white-gray-border'"
            ></db-google-auth>
          </div>-->
  <!--        <div class="db-google-divider" [class.slim]="slim">
            <span>Sign up with Email</span>
          </div>-->

          <div class="ds-input-wrap mb9">
            <input type="email" maxlength="100" name="email"  formControlName="email" [style.border-color]="(emailChecked && !userDoesNotExist) || (signUpForm.controls['email'].invalid && ((signUpForm.controls['email'].touched && !signUpForm.controls['email'].errors['required']) || formSubmitted)) || (serverErrors && serverErrors.fields.email) ? '#D41125' : null" (blur)="blurEmail()" class="ds-input sl-sign_up_email_field" [placeholder]="'text_createProfileEmail' | dbText">
            <span class="ds-input-error-msg" *ngIf="signUpForm.controls['email'].invalid && ((signUpForm.controls['email'].touched && !signUpForm.controls['email'].errors['required']) || formSubmitted) && !serverErrors">
      {{signUpForm.controls['email'].value.length ? ('text_invalidEmail' | dbText) : ('text_requiredEmail' | dbText)}}</span>
              <span class="ds-input-error-msg" *ngIf="signUpForm.controls['email'].valid && emailChecked && !userDoesNotExist || (serverErrors && serverErrors.fields.email)">
      {{'text_existEmail' | dbText}}</span>
            </div>

            <div class="auth-sign-up__group auth-sign-up__flname">
              <div class="ds-input-wrap short mb9">
                <input type="text" name="fname" maxlength="60" formControlName="firstName" [style.border-color]="(signUpForm.controls['firstName'].invalid && ((signUpForm.controls['firstName'].touched && !signUpForm.controls['firstName'].errors['required']) || formSubmitted)) || (serverErrors && serverErrors?.fields?.first_name) ? '#D41125' : null" class="ds-input" [placeholder]="'text_accountSettingsFirstName' | dbText">
                <span class="ds-input-error-msg"
                      *ngIf="(signUpForm.controls['firstName'].invalid && ((signUpForm.controls['firstName'].touched && !signUpForm.controls['firstName'].errors['required']) || formSubmitted)) || (serverErrors && serverErrors?.fields?.first_name)">
      {{
      serverErrors && serverErrors?.fields.first_name ? serverErrors.fields?.first_name : (signUpForm.controls['firstName'].errors?.link ? ('text_invalidFirstName' | dbText) : ('text_requiredFirstName' | dbText))
      }}
      </span>
      </div>

      <div class="ds-input-wrap short mb9">
        <input type="text" name="lname" maxlength="60" formControlName="lastName" [style.border-color]="(signUpForm.controls['lastName'].invalid && ((signUpForm.controls['lastName'].touched && !signUpForm.controls['lastName'].errors['required']) || formSubmitted)) || (serverErrors && serverErrors?.fields?.last_name) ? '#D41125' : null" class="ds-input" [placeholder]="'text_accountSettingsLastName' | dbText">
        <span class="ds-input-error-msg"
              *ngIf="signUpForm.controls['lastName'].invalid && ((signUpForm.controls['lastName'].touched && !signUpForm.controls['lastName'].errors['required']) || formSubmitted) || (serverErrors && serverErrors?.fields?.last_name)">
      {{
      serverErrors && serverErrors?.fields.last_name ? serverErrors.fields?.last_name : (signUpForm.controls['lastName'].errors?.link ? ('text_invalidLastName' | dbText) : ('text_requiredLastName' | dbText))
      }}
      </span>
      </div>
    </div>

    <div class="ds-input-wrap mb9">
      <div class="ds-input-password-wrap">
        <input #password type="password" class="ds-input" placeholder="password"  name="password" formControlName="password"
               (focus)="showPWDRequirements = true" (focusout)="showPWDRequirements = false"
               (ngModelChange)="progressPercent()"
               [placeholder]="'text_createProfilePassword' | dbText"
               [style.border-color]="(signUpForm.controls['password'].invalid && ((signUpForm.controls['password'].touched && !signUpForm.controls['password'].errors['required']) || formSubmitted)) ? '#D41125' : null">
        <a class="ds-input-password-trigger" (click)="password.type = password.type === 'text' ? 'password' : 'text'; password.focus()">
          <i class="db-icon {{password.type === 'text' ? 'db-icon-ds-eye' : 'db-icon-ds-eye-cancel'}}"></i>
                </a>
              </div>
              <span class="ds-input-error-msg"  *ngIf="(signUpForm.controls['password'].invalid && ((signUpForm.controls['password'].touched && !signUpForm.controls['password'].errors['required']) || formSubmitted) ) || (serverErrors && serverErrors.fields['password'])">
      {{serverErrors?.fields?.password || ('text_requiredPassword1' | dbText)}}</span>
              <db-password-validation [formGroup]="signUpForm" *ngIf="showPWDRequirements" [isMobile]="true" [showOnTop]="!!isMobile"></db-password-validation>
            </div>

          </div>
        </div>

        <button class="ds-btn-purple-blue rectangle ds-btn-max"
                [ngClass]="{'ds-btn-disabled': !!loading}"
                (click)="onSignUpSubmit()">
          <span *ngIf="!loading">{{'Sign Up'}}</span>
          <db-loading-circular-spinner *ngIf="!!loading"></db-loading-circular-spinner>
        </button>
      }
    </form>
   </div>
  </div>
